import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import Form from "react-bootstrap/Form";
import Button from 'react-bootstrap/Button';
import Alert from "react-bootstrap/Alert";
import { Formik, FormikErrors } from "formik";
import { useAuthState } from "react-firebase-hooks/auth";
import Row from "react-bootstrap/Row";

const axios = require("axios").default;

function User() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [formSubmitted, setFormSubmitted] = useState(false);
  interface FormValues {
    apellido1: string,
    apellido2: string,
    name: string,
    telefono: string,
    ugr: string,
  }
  return (
    <Row className="justify-content-md-center m-5">
      <Formik
      initialValues={{
        name: "",
        apellido1: "",
        apellido2: "",
        telefono: "",
        ugr: "",
      }}
      onSubmit={async (values, actions) => {
        actions.setSubmitting(true);
        setFormSubmitted(true);
        await axios.post("https://europe-west1-gran-recogida.cloudfunctions.net/api/volunteers",{
            name: values.name,
            apellido1: values.apellido1,
            apellido2: values.apellido2,
            email: user?.email,
            telefono: values.telefono,
            uid: user?.uid,
            ugr: values.ugr === "true" ? true : false
        })
        .then((data: any) => {
          actions.setSubmitting(false);
          navigate("/new", {state: {userId: data.data.id}} );
        })
        .catch((error: any) => {
          setFormSubmitted(false);
          console.log(error);
        })
      }}
      validate={(values: FormValues) => {
        let errors: FormikErrors<FormValues> = {};
        if(!values.name) {
          errors.name = "Obligatorio"
        }
        if(!values.apellido1) {
          errors.apellido1 = "Obligatorio"
        }
        if(!values.telefono) {
          errors.telefono = "Obligatorio"
        }
        return errors;
      }}
      >
        {({errors, touched, values, handleSubmit, handleChange}) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control type="text" name="name" placeholder="Nombre" value={values.name} onChange={handleChange} />
              {errors.name && touched.name && <Alert key="danger" variant="danger">{errors.name}</Alert>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Apellido 1</Form.Label>
              <Form.Control type="text" name="apellido1" placeholder="Apellido 1"  value={values.apellido1} onChange={handleChange} />
              {errors.apellido1 && touched.apellido1 && <Alert variant="danger">{errors.apellido1}</Alert>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Apellido 2</Form.Label>
              <Form.Control type="text" name="apellido2" placeholder="Apellido 2"  value={values.apellido2} onChange={handleChange}  />
              {errors.apellido2 && touched.apellido2 && <Alert variant="danger">{errors.apellido2}</Alert>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Número de teléfono</Form.Label>
              <Form.Control type="text" name="telefono" placeholder="Número de teléfono"  value={values.telefono} onChange={handleChange} />
              {errors.telefono && touched.telefono && <Alert variant="danger">{errors.telefono}</Alert>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>¿Formas parte de la UGR?</Form.Label>
              <Form.Check type="checkbox" name="ugr" placeholder="" label="Quiero obtener el certificado UGR" value={values.ugr} onChange={handleChange} />
              {errors.ugr && touched.ugr && <Alert variant="danger">{errors.ugr}</Alert>}
            </Form.Group>

            <Button variant="primary" type="submit" disabled={formSubmitted}>
              Enviar
            </Button>
            {formSubmitted && 
              <div className="spinner-border"></div>
            }
          </Form>
        )}
    </Formik>
    </Row>
  );
}

export default User;